import { getSlicesContext, transformProperties } from '@/src/domains/prismic/helpers';
import { querySharedServices } from '@/src/domains/shared/services';
import { queryGlobalWorkforceReportPage } from '@/src/views/GlobalWorkforceReportPage/services';

export { GlobalWorkforceReportPage as default } from '@/src/views/GlobalWorkforceReportPage';

export async function getStaticProps({ preview = false, previewData = {}, locale }) {
  const dataContent = await queryGlobalWorkforceReportPage({ previewData, locale });

  if (!dataContent) {
    return {
      notFound: true,
    };
  }

  const {
    gatedFile,
    gatedFormId: formId,
    modalFormTitle,
    modalFormDescription,
    modalFormSubmitLabel,
    downloadButtonLabel,
    eventName,
  } = transformProperties(dataContent);

  const sharedServices = await querySharedServices({ previewData, locale });

  const body = await getSlicesContext(dataContent.body, {
    hero_section: async () => ({
      formId,
      gatedFile,
      modalFormTitle,
      modalFormDescription,
      modalFormSubmitLabel,
      eventName,
      downloadButtonLabel,
    }),
    what_you_get_slice: async () => ({
      formId,
      gatedFile,
      modalFormTitle,
      modalFormDescription,
      modalFormSubmitLabel,
      eventName,
      downloadButtonLabel,
    }),
    cta_section: async () => ({
      formId,
      gatedFile,
      modalFormTitle,
      modalFormDescription,
      modalFormSubmitLabel,
      eventName,
      downloadButtonLabel,
    }),
  });

  return {
    props: {
      ...dataContent,
      preview,
      sharedServices,
      body,
    },
  };
}
